import axios, { isUpstreamNotFound } from './upstreamAwareAxios';
import type { AxiosResponse } from 'axios';
import { getAuth } from '../providers/AppAuthProvider';
import { baseUrl } from '../providers/AppDataProvider';
//RedPacketTypeTwitterBinding RedPacketType = "TWITTER_BINDING"
// RedPacketTypeTwitterFollow  RedPacketType = "TWITTER_FOLLOW"
// 枚举类型
export enum RedPacketType {
  TWITTER_BINDING = 'TWITTER_BINDING',
  TWITTER_FOLLOW = 'TWITTER_FOLLOW',
  DEPOSIT = 'DEPOSIT',
  TRADING = 'TRADING',
  CRITICAL_HIT = 'CRITICAL_HIT',
}

export enum ThresholdTierType {
  DEPOSIT = 'DEPOSIT',
  TRADING = 'TRADING',
}

// export enum RedPacketConfigKey {
//   CRITICAL_HIT_BUDGET = 'CRITICAL_HIT_BUDGET',
//   LEADERBOARD_PRIZE_POOL = 'LEADERBOARD_PRIZE_POOL',
//   LUCKY_LOTTO_DAILY_PRIZE = 'LUCKY_LOTTO_DAILY_PRIZE',
//   RED_PACKET_TTL_DAYS = 'RED_PACKET_TTL_DAYS',
//   WITHDRAWAL_THRESHOLD = 'WITHDRAWAL_THRESHOLD',
//   CRITICAL_HIT_PROBABILITY = 'CRITICAL_HIT_PROBABILITY',
// }

export enum RedPacketStatus {
  PENDING = 'PENDING',
  CLAIMED = 'CLAIMED',
  EXPIRED = 'EXPIRED',
}

// 类型定义
export interface RedPacketStats {
  totalDistributed: string;
  totalWithdrawn: string;
  activeUsers: number;
  pendingWithdrawals: number;
  twitterBindingRedPackets: number;
  twitterFollowRedPackets: number;
  depositRedPackets: number;
  tradingRedPackets: number;
  criticalHitRedPackets: number;
  twitterBindingDistributedAmount: string;
  twitterFollowDistributedAmount: string;
  depositDistributedAmount: string;
  tradingDistributedAmount: string;
  criticalHitDistributedAmount: string;
  unopenedTwitterBindingAmount: number;
  unopenedTwitterFollowAmount: number;
  unopenedDepositAmount: number;
  unopenedTradingAmount: number;
  unopenedCriticalHitAmount: number;
  unopenedTwitterBindingCount: number;
  unopenedTwitterFollowCount: number;
  unopenedDepositCount: number;
  unopenedTradingCount: number;
  unopenedCriticalHitCount: number;
  twitterBindingConsumptionRate: string;
  twitterFollowConsumptionRate: string;
  depositConsumptionRate: string;
  tradingConsumptionRate: string;
  criticalHitConsumptionRate: string;
  criticalHitBudgetStats: CriticalHitBudgetStats;
}

export interface CriticalHitBudgetStats {
  totalBudget: string;
  spentAmount: string;
  remainingBudget: string;
  distributedCount: number;
  isActive: boolean;
}

export interface PoolStats {
  id: string;
  poolType: string;
  totalBudget: string;
  availableBalance: string;
  spentBalance: string;
  frozenBalance: string;
  spentPercentage: string;
  remainingPercentage: string;
  updatedAt: number;
}

export interface RewardPoolBalance {
  id: string;
  poolType: PoolType;
  totalBudget: string;
  availableBalance: string;
  spentBalance: string;
  frozenBalance: string;
  spentPercentage: string;
  remainingPercentage: string;
  updatedAt: number;
}

export interface SetRewardPoolBudgetInput {
  poolType: PoolType;
  totalBudget: string;
}

export interface RedPacketTypeStats {
  redPacketType: RedPacketType;
  unopenedAmount: string;
  unopenedCount: number;
  issuedAmount: string;
  issuedCount: number;
  claimedAmount: string;
  claimedCount: number;
  consumptionRate: string;
}

export interface DashboardStats {
  sharedPool: PoolStats;
  criticalHitPool: PoolStats;
  criticalHitDesignatedPool: PoolStats;

  twitterBindingStats: RedPacketTypeStats;
  twitterFollowStats: RedPacketTypeStats;
  depositStats: RedPacketTypeStats;
  tradingStats: RedPacketTypeStats;
  criticalHitStats: RedPacketTypeStats;
  criticalHitDesignatedStats: RedPacketTypeStats;
}

export interface AmountRange {
  id: string;
  redPacketType: RedPacketType;
  minAmount: string;
  maxAmount: string;
  skewFactor?: number;
  isActive: boolean;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ThresholdTier {
  id: string;
  tierType: ThresholdTierType;
  thresholdAmount: string;
  packetsEarned: number;
  sortOrder: number;
  isActive: boolean;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CriticalHitTier {
  id: string;
  amount: string;
  probability: number;
  sortOrder: number;
  isActive: boolean;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface RedPacketConfig {
  id: string;
  configKey: string;
  value: string;
  description?: string;
  minValue?: string;
  maxValue?: string;
  updatedBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface GrantRedPacketInput {
  walletAddress: string;
  amount: string;
  type: RedPacketType;
  reason: string;
}

export interface GrantRedPacketResponse {
  id: string;
  userId: string;
  type: RedPacketType;
  amount: string;
  status: string;
  claimedAt?: string;
  createdAt: string;
}

export interface TimeSeriesStatItem {
  date: string;
  type: RedPacketType;
  createdCount: number;
  createdAmount: string;
  claimedCount: number;
  claimedAmount: string;
}

export interface RedPacketTimeSeriesStats {
  cumulative: TimeSeriesStatItem[];
  daily: TimeSeriesStatItem[];
}
export interface TradingTimeSeriesStatItem {
  date: string;
  tradingAmount: string;
  cumulativeTradingAmount: string;
}
export interface TradingTimeSeriesResponse {
  daily: TradingTimeSeriesStatItem[];
}

export interface DepositTimeSeriesStatItem {
  date: string;
  depositAmount: string;
  cumulativeDepositAmount: string;
}
export interface DepositTimeSeriesResponse {
  daily: DepositTimeSeriesStatItem[];
}

// Post Campaign Cleanup Stats Types
export interface CleanupRun {
  id: string;
  cutoffTime: number;
  status: string;
  expiredPacketsCount: number;
  expiredPacketsAmount: string;
  smallBalanceUsersCount: number;
  smallBalanceRecoveredAmount: string;
  autoClaimUsersCount: number;
  autoClaimAmount: string;
  autoClaimFailedCount: number;
  sharedPoolRecovered: string;
  criticalHitPoolRecovered: string;
  designatedPoolRecovered: string;
  startedAt: number;
  completedAt?: number;
  errorMessage?: string;
}

export interface PostCampaignCleanupStats {
  cleanupTriggered: boolean;
  scheduledTime?: number | null;
  latestRun?: CleanupRun;
}

export interface RedPacketRecord {
  id: string;
  userId: string;
  walletAddress: string;
  type: RedPacketType;
  amount: string;
  status: RedPacketStatus;
  createdAt: string;
  claimedAt?: string;
  expiresAt?: string;
  metadata?: string;
  updatedAt: string;
}

export interface RedPacketRecordFilter {
  userId?: string;
  walletAddress?: string;
  types?: RedPacketType[];
  statuses?: RedPacketStatus[];
  createdFrom?: string;
  createdTo?: string;
  claimedFrom?: string;
  claimedTo?: string;
}

export interface PaginationInput {
  limit: number;
  offset: number;
}

export interface RedPacketRecordSort {
  field: 'CLAIMED_AT' | 'CREATED_AT' | 'AMOUNT';
  direction: 'ASC' | 'DESC';
}

export interface GetRedPacketRecordsResponse {
  totalCount: number;
  records: RedPacketRecord[];
}

// API 调用函数
async function getAuthHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
}

function buildQuery(params: Record<string, any>) {
  const sp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    sp.set(k, String(v));
  });
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

function parseFilenameFromDisposition(disposition: string | null) {
  if (!disposition) return null;
  const m = disposition.match(/filename\s*=\s*"([^"]+)"/i);
  return m?.[1] ?? null;
}

export async function exportRedPacketRecordsCsv(params: {
  filter?: RedPacketRecordFilter;
  sort?: RedPacketRecordSort;
  timezone?: string;
  maxRows?: number;
}) {
  const { accessToken } = (await getAuth()) || {};
  const headers: Record<string, string> = {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'text/csv,*/*',
  };

  const q: Record<string, any> = {};
  if (params.filter) q.filter = JSON.stringify(params.filter);
  if (params.sort) q.sort = JSON.stringify(params.sort);
  if (params.timezone) q.timezone = params.timezone;
  if (params.maxRows) q.maxRows = params.maxRows;

  const url = `${baseUrl}/redpacket/records/export${buildQuery(q)}`;

  const res = await fetch(url, { method: 'GET', headers });

  if (!res.ok) {
    let msg = `Export failed (${res.status})`;
    try {
      const ct = res.headers.get('content-type') || '';
      if (ct.includes('application/json')) {
        const j = await res.json();
        msg = j?.message ?? msg;
      } else {
        const t = await res.text();
        if (t) msg = t;
      }
    } catch {
      // ignore
    }
    throw new Error(msg);
  }

  const blob = await res.blob();
  const filename =
    parseFilenameFromDisposition(res.headers.get('content-disposition')) ||
    `redpacket-records-${Date.now()}.csv`;

  return { blob, filename };
}

// 1. 获取红包统计
export async function getRedPacketStats(): Promise<RedPacketStats> {
  const headers = await getAuthHeaders();
  const response = await axios.get<RedPacketStats>(`${baseUrl}/redpacket/stats`, { headers });
  return response.data;
}
// 1-1. 获取仪表盘统计信息
export async function getDashboardStats(): Promise<DashboardStats> {
  const headers = await getAuthHeaders();
  const response = await axios.get<any>(`${baseUrl}/redpacket/dashboard-stats`, { headers });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 2. 获取时间序列统计
export async function getRedPacketTimeSeriesStats(
  startDate?: string,
  endDate?: string
): Promise<RedPacketTimeSeriesStats> {
  const headers = await getAuthHeaders();
  const params: any = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  const response = await axios.get<any>(`${baseUrl}/redpacket/timeseries-stats`, {
    headers,
    params,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  // 确保返回正确的数据结构
  if (response.data?.daily && response.data?.cumulative) {
    return response.data;
  }
  // 如果没有数据，返回空结构
  return {
    daily: [],
    cumulative: [],
  };
}
export async function getTradingTimeSeriesStats(
  startDate?: any, // Dayjs | null | string
  endDate?: any // Dayjs | null | string
): Promise<TradingTimeSeriesResponse> {
  const headers = await getAuthHeaders();
  const params: any = {};

  // 处理日期：如果是 Dayjs 对象，转换为时间戳字符串；如果是 null，不传参数
  if (startDate && typeof startDate === 'object' && startDate.startOf) {
    // Dayjs 对象
    params.startDate = startDate.startOf('day').valueOf().toString();
  } else if (typeof startDate === 'string') {
    // 字符串（时间戳）
    params.startDate = startDate;
  }

  if (endDate && typeof endDate === 'object' && endDate.endOf) {
    // Dayjs 对象
    params.endDate = endDate.endOf('day').valueOf().toString();
  } else if (typeof endDate === 'string') {
    // 字符串（时间戳）
    params.endDate = endDate;
  }

  const response = await axios.get<any>(`${baseUrl}/redpacket/trading-timeseries-stats`, {
    headers,
    params,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  // 确保返回正确的数据结构
  if (response.data?.daily) {
    return response.data;
  }
  // 如果没有数据，返回空结构
  return {
    daily: [],
  };
}
export async function getDepositTimeSeriesStats(
  startDate?: any, // Dayjs | null | string
  endDate?: any // Dayjs | null | string
): Promise<DepositTimeSeriesResponse> {
  const headers = await getAuthHeaders();
  const params: any = {};

  // 处理日期：如果是 Dayjs 对象，转换为时间戳字符串；如果是 null，不传参数
  if (startDate && typeof startDate === 'object' && startDate.startOf) {
    // Dayjs 对象
    params.startDate = startDate.startOf('day').valueOf().toString();
  } else if (typeof startDate === 'string') {
    // 字符串（时间戳）
    params.startDate = startDate;
  }

  if (endDate && typeof endDate === 'object' && endDate.endOf) {
    // Dayjs 对象
    params.endDate = endDate.endOf('day').valueOf().toString();
  } else if (typeof endDate === 'string') {
    // 字符串（时间戳）
    params.endDate = endDate;
  }

  const response = await axios.get<any>(`${baseUrl}/redpacket/deposit-timeseries-stats`, {
    headers,
    params,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  // 确保返回正确的数据结构
  if (response.data?.daily) {
    return response.data;
  }
  // 如果没有数据，返回空结构
  return {
    daily: [],
  };
}

// 3. 获取红包类型配置
export async function getAmountRanges(redPacketType: RedPacketType): Promise<AmountRange[]> {
  const headers = await getAuthHeaders();
  let response: AxiosResponse<any>;
  try {
    response = await axios.get<any>(`${baseUrl}/redpacket/amount-ranges`, {
      headers,
      params: { redPacketType },
    });
  } catch (e) {
    if (isUpstreamNotFound(e)) return [];
    throw e;
  }
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    if (error.message === 'record not found') {
      return [];
    }
    throw new Error(error.message);
  }
  return Array.isArray(response.data) ? response.data : [];
}

// 4. 创建红包类型配置
export async function createAmountRange(data: {
  redPacketType: RedPacketType;
  minAmount: string;
  maxAmount: string;
  skewFactor?: number;
  description?: string;
}): Promise<AmountRange> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/amount-ranges`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 5. 更新红包类型配置
export async function updateAmountRange(data: {
  id: string;
  minAmount?: string;
  maxAmount?: string;
  skewFactor?: number;
  isActive?: boolean;
  description?: string;
}): Promise<AmountRange> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/amount-ranges/update`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 6. 获取充值/交易阶梯配置
export async function getThresholdTiers(tierType: ThresholdTierType): Promise<ThresholdTier[]> {
  const headers = await getAuthHeaders();
  let response: AxiosResponse<any>;
  try {
    response = await axios.get<any>(`${baseUrl}/redpacket/threshold-tiers`, {
      headers,
      params: { tierType },
    });
  } catch (e) {
    if (isUpstreamNotFound(e)) return [];
    throw e;
  }
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    if (error.message === 'record not found') {
      return [];
    }
    throw new Error(error.message);
  }
  return Array.isArray(response.data) ? response.data : [];
}

// 7. 创建充值/交易阶梯配置
export async function createThresholdTier(data: {
  tierType: ThresholdTierType;
  thresholdAmount: string;
  packetsEarned: number;
  sortOrder: number;
  description?: string;
}): Promise<ThresholdTier> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/threshold-tiers`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 8. 更新充值/交易阶梯配置
export async function updateThresholdTier(data: {
  id: string;
  thresholdAmount?: string;
  packetsEarned?: number;
  sortOrder?: number;
  isActive?: boolean;
  description?: string;
}): Promise<ThresholdTier> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/threshold-tiers/update`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 9. 删除充值/交易阶梯配置
export async function deleteThresholdTier(id: string): Promise<any> {
  const headers = await getAuthHeaders();
  let response: AxiosResponse<any>;
  try {
    response = await axios.post<any>(
      `${baseUrl}/redpacket/threshold-tiers/${id}/delete`,
      {},
      { headers }
    );
  } catch (e) {
    if (isUpstreamNotFound(e)) return undefined;
    throw e;
  }
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    if (error.message === 'record not found') {
      return response;
    }
    throw new Error(error.message);
  }
  return response.data;
}

// 10. 获取暴击金额权重配置
export async function getCriticalHitTiers(): Promise<CriticalHitTier[]> {
  const headers = await getAuthHeaders();
  let response: AxiosResponse<any>;
  try {
    response = await axios.get<any>(`${baseUrl}/redpacket/critical-hit-tiers`, { headers });
  } catch (e) {
    if (isUpstreamNotFound(e)) return [];
    throw e;
  }
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    if (error.message === 'record not found') {
      return [];
    }
    throw new Error(error.message);
  }
  return Array.isArray(response.data) ? response.data : [];
}

// 11. 创建暴击金额权重配置
export async function createCriticalHitTier(data: {
  amount: string;
  probability: number;
  sortOrder: number;
  description?: string;
}): Promise<CriticalHitTier> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/critical-hit-tiers`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 12. 更新暴击金额权重配置
export async function updateCriticalHitTier(data: {
  id: string;
  amount?: string;
  probability?: number;
  sortOrder?: number;
  isActive?: boolean;
  description?: string;
}): Promise<CriticalHitTier> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/critical-hit-tiers/update`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 13. 删除暴击金额权重配置
export async function deleteCriticalHitTier(id: string): Promise<void> {
  const headers = await getAuthHeaders();
  await axios.post<void>(`${baseUrl}/redpacket/critical-hit-tiers/${id}/delete`, {}, { headers });
}

// 14. 指定红包（发放红包）
export async function grantRedPacket(data: GrantRedPacketInput): Promise<GrantRedPacketResponse> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/grant`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 15. 获取用户红包情况（待生效干预列表）
export async function getAllUserRedPackets(
  offset: number = 0,
  limit: number = 10
): Promise<{
  totalCount: number;
  records: any[];
}> {
  const headers = await getAuthHeaders();
  const response = await axios.get(`${baseUrl}/redpacket/user-redpackets`, {
    headers,
    params: { offset, limit },
  });
  return response.data;
}

// 16. 获取提现配置
export async function getRedPacketConfigs(): Promise<RedPacketConfig[]> {
  const headers = await getAuthHeaders();
  let response: AxiosResponse<any>;
  try {
    response = await axios.get<any>(`${baseUrl}/redpacket/configs`, {
      headers,
    });
  } catch (e) {
    if (isUpstreamNotFound(e)) return [];
    throw e;
  }
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    if (error.message === 'record not found') {
      return [];
    }
    throw new Error(error.message);
  }
  //delete response.data campaign_start_date campaign_end_date
  if (response?.data && Array.isArray(response.data)) {
    // 定义需要删除的 configKey 列表
    const keysToRemove = ['campaign_start_date', 'campaign_end_date'];

    // 过滤数组，只保留 configKey 不在删除列表中的项
    response.data = response.data.filter((config: RedPacketConfig) => {
      return !keysToRemove.includes(config.configKey);
    });
  }
  return Array.isArray(response.data) ? response.data : [];
}

// 17. 创建提现配置
export async function createRedPacketConfig(data: {
  configKey: string;
  value?: string;
  description?: string;
  minValue?: string;
  maxValue?: string;
  reason?: string;
}): Promise<RedPacketConfig> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/configs`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 18. 更新提现配置
export async function updateRedPacketConfig(data: {
  configKey: string;
  value?: string;
  reason?: string;
}): Promise<RedPacketConfig> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/configs/update`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 19. 获取红包发放记录
export async function getRedPacketRecords(
  filter?: RedPacketRecordFilter,
  pagination?: PaginationInput,
  sort?: RedPacketRecordSort
): Promise<GetRedPacketRecordsResponse> {
  const headers = await getAuthHeaders();
  const params: any = {};
  if (filter) params.filter = JSON.stringify(filter);
  if (pagination) params.pagination = JSON.stringify(pagination);
  if (sort) params.sort = JSON.stringify(sort);
  const response = await axios.get<any>(`${baseUrl}/redpacket/records`, {
    headers,
    params,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// LottoDrawConfig 类型定义
export interface LottoDrawConfig {
  id: string;
  drawTimeUtc: string;
  prizeAmount: string;
  totalBudget: string;
  remainingBudget: string;
  fundPoolAddress: string;
  isActive: boolean;
  eligibilityThreshold: number;
  createdAt: number;
  updatedAt: number;
}

export interface CreateLottoDrawConfigInput {
  drawTimeUtc: string;
  prizeAmount: string;
  totalBudget: string;
  fundPoolAddress: string;
  isActive?: boolean;
  eligibilityThreshold: number;
}

export interface UpdateLottoDrawConfigInput {
  id: string;
  drawTimeUtc?: string;
  prizeAmount?: string;
  totalBudget?: string;
  remainingBudget?: string;
  fundPoolAddress?: string;
  isActive?: boolean;
  eligibilityThreshold?: number;
}

// 20. 获取抽奖配置列表
export async function getLottoDrawConfigs(id?: string): Promise<LottoDrawConfig[]> {
  const headers = await getAuthHeaders();
  const params: any = {};
  if (id) params.id = id;
  let response: AxiosResponse<any>;
  try {
    response = await axios.get<any>(`${baseUrl}/redpacket/lotto-draw-configs`, {
      headers,
      params,
    });
  } catch (e) {
    if (isUpstreamNotFound(e)) return [];
    throw e;
  }
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    if (error.message === 'record not found') {
      return [];
    }
    throw new Error(error.message);
  }
  return Array.isArray(response.data) ? response.data : [];
}

// 20-1. 获取活跃的抽奖配置
export async function getActiveLottoDrawConfig(): Promise<LottoDrawConfig | null> {
  const headers = await getAuthHeaders();
  let response: AxiosResponse<any>;
  try {
    response = await axios.get<any>(`${baseUrl}/redpacket/lotto-draw-configs/active`, {
      headers,
    });
  } catch (e) {
    if (isUpstreamNotFound(e)) return null;
    throw e;
  }
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    if (error.message === 'record not found') {
      return null;
    }
    throw new Error(error.message);
  }
  return response.data || null;
}

// 21. 创建抽奖配置
export async function createLottoDrawConfig(
  data: CreateLottoDrawConfigInput
): Promise<LottoDrawConfig> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/lotto-draw-configs`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 22. 更新抽奖配置
export async function updateLottoDrawConfig(
  data: UpdateLottoDrawConfigInput
): Promise<LottoDrawConfig> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/lotto-draw-configs/update`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// DesignatedRedPacket 类型定义
export enum DesignatedRedPacketStatus {
  PENDING = 'PENDING',
  TRIGGERED = 'TRIGGERED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
}

export interface DesignatedRedPacket {
  id: string;
  walletAddress: string;
  designatedAmount: string;
  status: DesignatedRedPacketStatus;
  triggeredAt?: string;
  triggeredBy?: string;
  redPacketId?: string;
  createdBy?: string;
  expiresAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface DesignatedRedPacketFilter {
  walletAddress?: string;
  status?: DesignatedRedPacketStatus;
  createdFrom?: string;
  createdTo?: string;
}

export interface GetDesignatedRedPacketsResponse {
  totalCount: number;
  records: DesignatedRedPacket[];
}

export interface CreateDesignatedRedPacketInput {
  walletAddress: string;
  designatedAmount: string;
  expiresAt?: string;
}

export interface BatchDesignatedRedPacketInput {
  walletAddress: string;
  designatedAmount: string;
  expiresAt?: string;
}

export interface BatchDesignatedRedPacketResult {
  success: boolean;
  createdCount: number;
  totalAmountReserved: string;
  errorMessage?: string | null;
  designatedRedPackets: DesignatedRedPacket[];
}

export interface UpdateDesignatedRedPacketInput {
  id: string;
  designatedAmount?: string;
  status?: DesignatedRedPacketStatus;
  expiresAt?: string;
}

// 23. 获取指定红包列表
export async function getDesignatedRedPackets(
  filter?: DesignatedRedPacketFilter,
  pagination?: PaginationInput
): Promise<GetDesignatedRedPacketsResponse> {
  const headers = await getAuthHeaders();
  const params: any = {};
  if (filter) params.filter = JSON.stringify(filter);
  if (pagination) params.pagination = JSON.stringify(pagination);
  const response = await axios.get<any>(`${baseUrl}/redpacket/designated-redpackets`, {
    headers,
    params,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 24. 获取指定红包详情
export async function getDesignatedRedPacket(id: string): Promise<DesignatedRedPacket> {
  const headers = await getAuthHeaders();
  const response = await axios.get<DesignatedRedPacket>(
    `${baseUrl}/redpacket/designated-redpackets/${id}`,
    { headers }
  );
  return response.data;
}

// 25. 创建指定红包
export async function createDesignatedRedPacket(
  data: CreateDesignatedRedPacketInput
): Promise<DesignatedRedPacket> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/designated-redpackets`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 26. 更新指定红包
export async function updateDesignatedRedPacket(
  data: UpdateDesignatedRedPacketInput
): Promise<DesignatedRedPacket> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/designated-redpackets/update`,
    data,
    { headers }
  );
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 27. 删除指定红包
export async function deleteDesignatedRedPacket(id: string): Promise<void> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/designated-redpackets/${id}/delete`,
    {},
    { headers }
  );
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
}

// 28. 批量创建指定红包
export async function createBatchDesignatedRedPackets(
  inputs: BatchDesignatedRedPacketInput[]
): Promise<BatchDesignatedRedPacketResult> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/designated-redpackets/batch`,
    { inputs },
    { headers }
  );
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// DailyPrizePool 类型定义
export enum PoolType {
  SHARED = 'SHARED',
  CRITICAL_HIT = 'CRITICAL_HIT',
  CRITICAL_HIT_DESIGNATED = 'CRITICAL_HIT_DESIGNATED',
}

export interface DailyPrizePoolConfig {
  id: string;
  poolType: PoolType;
  dailyBudget: string;
  resetHourUTC: number;
  isActive: boolean;
  description?: string;
  updatedBy?: string;
  createdAt: number;
  updatedAt: number;
}

export interface DailyPrizePoolStatus {
  id: string;
  date: string;
  poolType: PoolType;
  totalBudget: string;
  reservedAmount: string;
  spentAmount: string;
  remainingAmount: string;
  packetsIssued: number;
  packetsClaimed: number;
  consumptionRate: string;
  createdAt: number;
  updatedAt: number;
  isAvailable: boolean;
}

export interface DailyPrizePoolConfigAudit {
  id: string;
  poolType: PoolType;
  oldBudget: string | null;
  newBudget: string;
  changedBy: string | null;
  changeReason: string | null;
  createdAt: number;
}

export interface DailyPrizePoolStatusRangeFilter {
  startDate?: string;
  endDate?: string;
  poolType?: PoolType;
}

export interface DailyPrizePoolConfigAuditFilter {
  poolType?: PoolType;
}

export interface GetDailyPrizePoolStatusRangeResponse {
  totalCount: number;
  records: DailyPrizePoolStatus[];
}

export interface GetDailyPrizePoolConfigAuditHistoryResponse {
  totalCount: number;
  records: DailyPrizePoolConfigAudit[];
}

export interface DailyPrizePoolSummary {
  isAnyPoolDepleted: boolean;
  depletionMessage?: string;
  sharedPoolConfig?: DailyPrizePoolConfig;
  criticalHitPoolConfig?: DailyPrizePoolConfig;
  criticalHitDesignatedPoolConfig?: DailyPrizePoolConfig;
  sharedPoolStatus?: DailyPrizePoolStatus;
  criticalHitPoolStatus?: DailyPrizePoolStatus;
  criticalHitDesignatedPoolStatus?: DailyPrizePoolStatus;
}

export interface CreateDailyPrizePoolConfigInput {
  poolType: PoolType;
  dailyBudget: string;
  resetHourUTC: number;
  isActive?: boolean;
  description?: string;
}

export interface UpdateDailyPrizePoolConfigInput {
  poolType: PoolType;
  dailyBudget?: string;
  changeReason?: string;
}

// 28. 获取每日奖金池汇总
export async function getDailyPrizePoolSummary(): Promise<DailyPrizePoolSummary> {
  const headers = await getAuthHeaders();
  const response = await axios.get<any>(`${baseUrl}/redpacket/daily-prize-pool-summary`, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 29. 创建每日奖金池配置
export async function createDailyPrizePoolConfig(
  data: CreateDailyPrizePoolConfigInput
): Promise<DailyPrizePoolConfig> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/daily-prize-pool-configs`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 30. 更新每日奖金池配置
// @ts-ignore
export async function updateDailyPrizePoolConfig(
  data: UpdateDailyPrizePoolConfigInput
): Promise<DailyPrizePoolConfig> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/daily-prize-pool-configs/update`,
    data,
    { headers }
  );
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 31. 每日奖金池状态记录（分页+筛选）
export async function getDailyPrizePoolStatusRange(
  filter?: DailyPrizePoolStatusRangeFilter,
  pagination?: { limit: number; offset: number }
): Promise<GetDailyPrizePoolStatusRangeResponse> {
  const headers = await getAuthHeaders();
  const params: Record<string, string> = {};
  if (filter) params.filter = JSON.stringify(filter);
  if (pagination) params.pagination = JSON.stringify(pagination);
  const response = await axios.get<GetDailyPrizePoolStatusRangeResponse>(
    `${baseUrl}/redpacket/daily-prize-pool-status-range`,
    { headers, params }
  );
  const data = response.data as any;
  if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
    const error = data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 32. 每日奖金池配置审计历史（分页+筛选）
export async function getDailyPrizePoolConfigAuditHistory(
  filter?: DailyPrizePoolConfigAuditFilter,
  pagination?: { limit: number; offset: number }
): Promise<GetDailyPrizePoolConfigAuditHistoryResponse> {
  const headers = await getAuthHeaders();
  const params: Record<string, string> = {};
  if (filter) params.filter = JSON.stringify(filter);
  if (pagination) params.pagination = JSON.stringify(pagination);
  const response = await axios.get<GetDailyPrizePoolConfigAuditHistoryResponse>(
    `${baseUrl}/redpacket/daily-prize-pool-config-audit-history`,
    { headers, params }
  );
  const data = response.data as any;
  if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
    const error = data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// FeatureFlags 类型定义
export enum FeatureFlagKey {
  V2_ENABLED = 'V2_ENABLED',
  LEADERBOARD_ENABLED = 'LEADERBOARD_ENABLED',
  LUCKY_LOTTO_ENABLED = 'LUCKY_LOTTO_ENABLED',
  OVERLAY_ENABLED = 'OVERLAY_ENABLED',
  CLAIM_ENABLED_H5 = 'CLAIM_ENABLED_H5',
  CLAIM_ENABLED_WEB = 'CLAIM_ENABLED_WEB',
  CLAIM_ENABLED_MOBILE = 'CLAIM_ENABLED_MOBILE',
  WITHDRAWAL_ENABLED_H5 = 'WITHDRAWAL_ENABLED_H5',
  WITHDRAWAL_ENABLED_WEB = 'WITHDRAWAL_ENABLED_WEB',
  WITHDRAWAL_ENABLED_MOBILE = 'WITHDRAWAL_ENABLED_MOBILE',
}

export interface FeatureFlagsEnvDefaults {
  v2Enabled: boolean;
  leaderboardEnabled: boolean;
  luckyLottoEnabled: boolean;
  overlayEnabled?: boolean;
  claimEnabledH5?: boolean;
  claimEnabledWeb?: boolean;
  claimEnabledMobile?: boolean;
  withdrawalEnabledH5?: boolean;
  withdrawalEnabledWeb?: boolean;
  withdrawalEnabledMobile?: boolean;
}

export interface FeatureFlags {
  v2Enabled: boolean;
  leaderboardEnabled: boolean;
  luckyLottoEnabled: boolean;
  overlayEnabled?: boolean;
  claimEnabledH5?: boolean;
  claimEnabledWeb?: boolean;
  claimEnabledMobile?: boolean;
  withdrawalEnabledH5?: boolean;
  withdrawalEnabledWeb?: boolean;
  withdrawalEnabledMobile?: boolean;
  envDefaults: FeatureFlagsEnvDefaults;
}

export interface FeatureFlag {
  id: string;
  flagKey: FeatureFlagKey;
  enabled: boolean;
  description?: string;
  updatedBy?: string;
  createdAt: number;
  updatedAt: number;
}

export interface GetFeatureFlagsResponse {
  status: FeatureFlags;
  flags: FeatureFlag[];
}

export interface BulkUpdateFeatureFlagsInput {
  v2Enabled?: boolean;
  leaderboardEnabled?: boolean;
  luckyLottoEnabled?: boolean;
  overlayEnabled?: boolean;
  claimEnabledH5?: boolean;
  claimEnabledWeb?: boolean;
  claimEnabledMobile?: boolean;
  withdrawalEnabledH5?: boolean;
  withdrawalEnabledWeb?: boolean;
  withdrawalEnabledMobile?: boolean;
  reason?: string;
}

export interface UpdateFeatureFlagInput {
  flagKey: FeatureFlagKey;
  enabled: boolean;
  reason?: string;
}

// 31. 获取功能开关
export async function getFeatureFlags(flagKey?: FeatureFlagKey): Promise<GetFeatureFlagsResponse> {
  const headers = await getAuthHeaders();
  const params: any = {};
  if (flagKey) params.flagKey = flagKey;
  const response = await axios.get<any>(`${baseUrl}/redpacket/feature-flags`, {
    headers,
    params,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 32. 批量更新功能开关
export async function bulkUpdateFeatureFlags(
  data: BulkUpdateFeatureFlagsInput
): Promise<FeatureFlags> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/feature-flags/bulk-update`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 32-1. 更新单个功能开关
export async function updateFeatureFlag(
  data: UpdateFeatureFlagInput
): Promise<FeatureFlag> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/feature-flags/update`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// Campaign Dates 类型定义
export interface CampaignStatus {
  startDate?: string;
  endDate?: string;
  isActive: boolean;
  statusMessage: string;
  startTimestamp?: number;
  endTimestamp?: number;
}

export interface SetCampaignDatesInput {
  startDate?: string | null;
  endDate?: string | null;
  reason?: string;
}

// 33. 获取活动状态
export async function getCampaignStatus(): Promise<CampaignStatus> {
  const headers = await getAuthHeaders();
  const response = await axios.get<any>(`${baseUrl}/redpacket/campaign-status`, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 34. 设置活动日期
export async function setCampaignDates(data: SetCampaignDatesInput): Promise<CampaignStatus> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/campaign-dates/set`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 35. 清除活动日期
export async function clearCampaignDates(reason?: string): Promise<CampaignStatus> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/campaign-dates/clear`,
    { reason },
    { headers }
  );
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 36. 获取奖励池余额列表
export async function getRewardPoolBalances(): Promise<RewardPoolBalance[]> {
  const headers = await getAuthHeaders();
  const response = await axios.get<any>(`${baseUrl}/redpacket/reward-pool-balances`, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data || [];
}

// 37. 设置奖励池预算
export async function setRewardPoolBudget(
  data: SetRewardPoolBudgetInput
): Promise<RewardPoolBalance> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/reward-pool-budget/set`, data, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// Overlay Configuration 类型定义
export interface OverlayStatus {
  enabled: boolean;
  removalTime?: string | null;
  overlayType?: string;
  isCurrentlyShowing: boolean;
  countdownSeconds?: number | null;
}

export interface SetOverlayConfigInput {
  enabled: boolean;
  removalTime?: string | null;
  overlayType?: string| null;
  reason?: string;
}

// 38. 获取 Overlay 状态
export async function getOverlayStatus(): Promise<OverlayStatus> {
  const headers = await getAuthHeaders();
  const response = await axios.get<OverlayStatus>(`${baseUrl}/redpacket/overlay-status`, {
    headers,
  });
  const data = response.data as any;
  if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
    const error = data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 39. 设置 Overlay 配置
export async function setOverlayConfig(data: SetOverlayConfigInput): Promise<OverlayStatus> {
  const headers = await getAuthHeaders();
  const response = await axios.post<OverlayStatus>(
    `${baseUrl}/redpacket/overlay-config/set`,
    data,
    {
      headers,
    }
  );
  const result = response.data as any;
  if (result?.errors && Array.isArray(result.errors) && result.errors.length > 0) {
    const error = result.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// 40. 获取活动结束后的清理统计
export async function getPostCampaignCleanupStats(): Promise<PostCampaignCleanupStats> {
  const headers = await getAuthHeaders();
  const response = await axios.get<any>(`${baseUrl}/redpacket/post-campaign-cleanup-stats`, {
    headers,
  });
  // 处理 GraphQL 错误响应
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function setCleanupScheduledTime(
  scheduledTime: string,
  reason: string
): Promise<PostCampaignCleanupStats> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/post-campaign-cleanup/scheduled-time/set`,
    { scheduledTime, reason },
    { headers }
  );
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function clearCleanupScheduledTime(reason: string): Promise<PostCampaignCleanupStats> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/post-campaign-cleanup/scheduled-time/clear`,
    { reason },
    { headers }
  );
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// Leaderboard Cycle 类型定义
export enum CycleStatus {
  UPCOMING = 'UPCOMING',
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
}

export interface CycleRewardTier {
  id: string;
  cycleId: string;
  minRank: number;
  maxRank: number;
  rewardAmount: string;
  description?: string | null;
  createdAt: number;
  updatedAt: number;
}

export interface LeaderboardCycle {
  id: string;
  cycleNumber: number;
  startTime: string;
  endTime: string;
  status: CycleStatus;
  rewardAutoTransferEnabled?: boolean | null;
  /** RFC3339 / ISO8601 — must be after endTime when auto transfer is enabled */
  rewardTransferTime?: string | null;
  rewardTransferStatus?: string | null;
  rewardTransferCompletedAt?: string | number | null;
  rewardTiers?: CycleRewardTier[];
  createdAt: number;
  updatedAt: number;
}

export interface LeaderboardCycleStats {
  cycleId: string;
  totalParticipants: number;
  totalVolume: string;
}

export interface LeaderboardCycleConnection {
  cycles: LeaderboardCycle[];
  totalCount: number;
}

export interface LeaderboardCycleFilter {
  status?: CycleStatus;
}

export interface CycleTopUser {
  userId: string;
  walletAddress: string;
  tradingVolume: string;
  rank: number;
  firstTradeAt?: number;
  lastTradeAt?: number;
}

export interface CycleTopUsersResult {
  cycle: LeaderboardCycle;
  users: CycleTopUser[];
  totalCount: number;
}

export interface CreateCycleRewardTierInput {
  minRank: number;
  maxRank: number;
  rewardAmount: string;
  description?: string | null;
}

export interface CreateLeaderboardCycleInput {
  startTime: string;
  endTime: string;
  rewardAutoTransferEnabled?: boolean | null;
  rewardTransferTime?: string | null;
  rewardTiers?: CreateCycleRewardTierInput[] | null;
}

export interface UpdateLeaderboardCycleInput {
  id: string;
  startTime?: string;
  endTime?: string;
  rewardAutoTransferEnabled?: boolean | null;
  rewardTransferTime?: string | null;
  /** When true, backend clears scheduled reward transfer time */
  clearRewardTransferTime?: boolean;
}

export interface UpdateCycleRewardTierInput {
  id: string;
  minRank?: number;
  maxRank?: number;
  rewardAmount?: string;
  description?: string | null;
}

// Leaderboard Cycle API 调用函数
export async function getLeaderboardCycles(
  filter?: LeaderboardCycleFilter,
  limit?: number,
  offset?: number
): Promise<LeaderboardCycleConnection> {
  const headers = await getAuthHeaders();
  const params: any = {};
  if (filter?.status) params.status = filter.status;
  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;
  const response = await axios.get<any>(`${baseUrl}/redpacket/leaderboard-cycles`, {
    headers,
    params,
  });
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data || {cycles: [], totalCount: 0};
}

export async function getLeaderboardCycleStats(cycleId: string): Promise<LeaderboardCycleStats> {
  const headers = await getAuthHeaders();
  const response = await axios.get<any>(
    `${baseUrl}/redpacket/leaderboard-cycles/${cycleId}/stats`,
    {headers}
  );
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function getLeaderboardCycleTopUsers(
  cycleId?: string,
  limit?: number
): Promise<CycleTopUsersResult> {
  const headers = await getAuthHeaders();
  const params: any = {};
  if (cycleId) params.cycleId = cycleId;
  if (limit !== undefined) params.limit = limit;
  const response = await axios.get<any>(`${baseUrl}/redpacket/leaderboard-cycles/top-users`, {
    headers,
    params,
  });
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function createLeaderboardCycle(
  data: CreateLeaderboardCycleInput
): Promise<LeaderboardCycle> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/leaderboard-cycles`, data, {
    headers,
  });
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function updateLeaderboardCycle(
  data: UpdateLeaderboardCycleInput
): Promise<LeaderboardCycle> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/leaderboard-cycles/update`,
    data,
    {headers}
  );
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function getLeaderboardCycle(id: string): Promise<LeaderboardCycle> {
  const headers = await getAuthHeaders();
  const response = await axios.get<any>(`${baseUrl}/redpacket/leaderboard-cycles/${id}`, {
    headers,
  });
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function getCycleRewardTiers(cycleId: string): Promise<CycleRewardTier[]> {
  const headers = await getAuthHeaders();
  const response = await axios.get<any>(
    `${baseUrl}/redpacket/leaderboard-cycles/${cycleId}/reward-tiers`,
    {headers}
  );
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  const data = response.data;
  if (Array.isArray(data)) return data;
  if (data?.tiers && Array.isArray(data.tiers)) return data.tiers;
  return [];
}

export async function createCycleRewardTier(
  input: CreateCycleRewardTierInput & { cycleId: string }
): Promise<CycleRewardTier> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/cycle-reward-tiers`, input, {
    headers,
  });
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function updateCycleRewardTier(
  input: UpdateCycleRewardTierInput
): Promise<CycleRewardTier> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(`${baseUrl}/redpacket/cycle-reward-tiers/update`, input, {
    headers,
  });
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

export async function deleteCycleRewardTier(id: string): Promise<boolean> {
  const headers = await getAuthHeaders();
  const response = await axios.post<any>(
    `${baseUrl}/redpacket/cycle-reward-tiers/${id}/delete`,
    {},
    {headers}
  );
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data ?? true;
}

export async function deleteLeaderboardCycle(id: string): Promise<boolean> {
  const headers = await getAuthHeaders();
  const response = await axios.delete<any>(`${baseUrl}/redpacket/leaderboard-cycles/${id}`, {
    headers,
  });
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}

// Lucky Lotto History
export interface LuckyLottoWinner {
  userId: string;
  walletAddress: string;
  randomNumber: number;
  rank: number;
  prizeAmount: string;
  tradingVolume: string;
  drawTime: string;
}

export interface LuckyLottoDrawRecord {
  drawId: string;
  drawDate: string;
  drawTime: string;
  prizePerWinner: string;
  totalPrizeAmount: string;
  winnerCount: number;
  luckyNumbers: number[];
  participantCount: number;
  transactionHashes: string[];
  prizeDistributed: boolean;
  distributedAt?: string;
  createdAt: string;
  winners: LuckyLottoWinner[];
}

export interface GetAdminLuckyLottoHistoryResponse {
  totalCount: number;
  records: LuckyLottoDrawRecord[];
}

export async function getAdminLuckyLottoHistory(
  limit: number = 20,
  offset: number = 0,
  drawDate?: string
): Promise<GetAdminLuckyLottoHistoryResponse> {
  const headers = await getAuthHeaders();
  const params: { limit: number; offset: number; drawDate?: string } = { limit, offset };
  if (drawDate) params.drawDate = drawDate;
  const response = await axios.get<any>(`${baseUrl}/redpacket/lucky-lotto-history`, {
    headers,
    params,
  });
  if (response.data?.errors && response.data?.errors.length > 0) {
    const error = response.data.errors[0];
    throw new Error(error.message);
  }
  return response.data;
}
